//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../GeometricUtilities/GeometricUtilities.LawBuilder.js";
import "../no/ScCollector.js";
import "../no/SelectFaceList.js";
import "../no/Section.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[1,"AngularLaw",0,"GeometricUtilities.LawBuilder",0],[1,"Faces",0,"ScCollector",0],[1,"NormalFaceList",0,"SelectFaceList",1],[1,"OrientationCurve",0,"Section",0],[0,"OrientationOption",1,0],[0,"OrientationPoint",1,"Point",0],[0,"OrientationVector",1,"Direction",0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.OrientationMethodBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.OrientationMethodBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.OrientationMethodBuilder.OrientationOptions = Object.freeze({
    "Fixed" : "Fixed", "ByFaceNormals" : "ByFaceNormals", "ByVectorDirection" : "ByVectorDirection", "ByAnotherCurve" : "ByAnotherCurve", "ByAPoint" : "ByAPoint", "ByAngularLaw" : "ByAngularLaw", "ByForcedDirection" : "ByForcedDirection"});

export default SPLM;